import { render, staticRenderFns } from "./DetailsMechanicalFixation.vue?vue&type=template&id=03509dbe&"
import script from "./DetailsMechanicalFixation.vue?vue&type=script&lang=js&"
export * from "./DetailsMechanicalFixation.vue?vue&type=script&lang=js&"
import style0 from "./DetailsMechanicalFixation.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports